import React from "react";
import { Button, Modal } from "react-bootstrap";
import { emptyString } from "../../../constants";

export const GenericModal = (props) => {
  // Destructuring props
  const {
    title,
    reset,
    isOpen,
    onHide,
    newUser,
    onClose,
    onSubmit,
    children,
    helpModal,
    setRowData,
    setNewUser,
    addNewUser,
    handleSubmit,
    configuration,
    newButtonFlag,
    isBlockNavigation,
    isSubmitDisabled = false,
  } = props;

  const {
    size,
    animate,
    newBtnText,
    addBtnText,
    backBtnText,
    submitBtnText,
    cancelBtnText,
    submitBtnVariant,
    cancelBtnVariant,
    newButtonVariant,
  } = configuration;

  return (
    <Modal
      centered
      show={isOpen}
      size={size}
      onHide={isBlockNavigation ? onHide : onClose}
      animation={animate}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className={`${helpModal ? "fw-bold" : emptyString}`}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        {newButtonFlag ? (
          <Button
            onClick={() => {
              setNewUser(!newUser);
            }}
            variant={newButtonVariant}
            className="green-background-color green-border"
          >
            {newUser ? backBtnText : newBtnText}
          </Button>
        ) : (
          <></>
        )}
        {newUser ? (
          <Button
            type="submit"
            className="btn btn-dark"
            onClick={handleSubmit(addNewUser)}
          >
            {addBtnText}
          </Button>
        ) : (
          <Button
            onClick={onSubmit}
            variant={submitBtnVariant}
            disabled={isSubmitDisabled}
          >
            {submitBtnText}
          </Button>
        )}
        <Button
          onClick={() => {
            onClose();
            if (newButtonFlag) {
              setRowData({});
              reset();
            }
          }}
          variant={cancelBtnVariant}
        >
          {cancelBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
